module.exports = __webpack_public_path__ + "img/ic_playing.39080547.gif";